import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd90eaac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "after-type-l" }
const _hoisted_3 = { class: "after-type-text" }
const _hoisted_4 = { class: "after-type-title" }
const _hoisted_5 = {
  key: 0,
  class: "after-type-explain"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'afterType',
  props: {
    /** 服务类型数据 
     * leftIcon 左边的图标 
     * title 标题
     * explain 标题下方的说明 
     * rightIcon 右边的图标
     *  */
    data: {
        type: Array,
        require: true,
    },
    lefterSize:{
        type:String,
        default:'0.67rem'
    }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props



const handleAfterType = (row: any) => {

    emit('click', row)
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "after-type",
      onClick: ($event: any) => (handleAfterType(item))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_icon, {
          size: __props.lefterSize,
          name: _ctx.webpFilters(item.leftIcon),
          class: "shop-icon"
        }, null, 8, ["size", "name"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _renderSlot(_ctx.$slots, "titleLeft")
          ]),
          (item.explain)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.explain), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_van_icon, {
        name: _ctx.webpFilters(item.rightIcon),
        class: "arrow-icon",
        size: "0.43rem",
        color: "#999999"
      }, null, 8, ["name"])
    ], 8, _hoisted_1))
  }), 256))
}
}

})